<template>
  <v-list-item class="mb-0 justify-space-between pl-0">
    <v-list-item-content class="pl-2">
      <v-list-item-title class="text-h5">
        <strong class="mr-1 font-weight-black">Menu</strong>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn icon @click.stop="mini = !mini">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
// Utilities
import { sync } from 'vuex-pathify'
export default {
  name: "DefaultDrawerHeader",

  computed: {mini: sync("app/mini") },
};
</script>
